module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_9016.63c9161c.png";